import React, { useEffect } from "react";
import { getActivityLogAPI } from "../service/AuthService";
import moment from "moment";
import { useSelector } from "react-redux";

export default function ActivityLog() {
  const [data, setData] = React.useState([]);
  const userData = useSelector((state) => state.account.userData);
  const getActivities = async () => {
    const { response } = await getActivityLogAPI({
      pageSize: 100,
      from: moment().subtract(1, "months"),
      to: moment(),
      userName: userData?.username,
      activityLogType: "LOGIN",
    });
    if (response) {
      setData(response.content);
    }
  };
  useEffect(() => {
    getActivities();
  }, []);
  return (
    <app-activity-log _nghost-ng-c3259574574="" className="ng-star-inserted">
      <div _ngcontent-ng-c3259574574="" className="main">
        <div
          _ngcontent-ng-c3259574574=""
          className="animated fadeIn divider-top"
        >
          <div
            _ngcontent-ng-c3259574574=""
            className="row"
            style={{ marginTop: 23 }}
          >
            <div
              _ngcontent-ng-c3259574574=""
              className="col-sm-12 col-md-12 p-mobile-1 main-card-con"
            >
              <div
                _ngcontent-ng-c3259574574=""
                className="card card-accent-primary"
              >
                <div
                  _ngcontent-ng-c3259574574=""
                  className="card-header account-detail-head"
                >
                  <span _ngcontent-ng-c3259574574="" className="acc-inn-head">
                    Activity Log
                  </span>
                </div>
                <div
                  _ngcontent-ng-c3259574574=""
                  className="card-body account-stat-body"
                >
                  <div _ngcontent-ng-c3259574574="" className="row">
                    <div
                      _ngcontent-ng-c3259574574=""
                      className="col-md-12 p-mobile-1"
                    >
                      <div
                        _ngcontent-ng-c3259574574=""
                        className="table-responsive"
                      >
                        <table
                          _ngcontent-ng-c3259574574=""
                          className="table table-bordered"
                        >
                          <thead _ngcontent-ng-c3259574574="">
                            <tr>
                              <th
                                _ngcontent-ng-c3259574574=""
                                style={{ minWidth: 160 }}
                              >
                                Login Date &amp; Time
                              </th>
                              <th _ngcontent-ng-c3259574574="" className="ls">
                                Login Status
                              </th>
                              <th _ngcontent-ng-c3259574574="">IP Address</th>

                              <th _ngcontent-ng-c3259574574="">Device</th>
                            </tr>
                          </thead>
                          <tbody _ngcontent-ng-c3259574574="">
                            {data?.map((item) => (
                              <tr
                                _ngcontent-ng-c3259574574=""
                                className="ng-star-inserted"
                              >
                                <td _ngcontent-ng-c3259574574="">
                                  {moment(item?.createdAt + "Z").format(
                                    "DD-MM-YYYY HH:mm:ss"
                                  )}
                                </td>
                                <td _ngcontent-ng-c3259574574="">
                                  <span
                                    _ngcontent-ng-c3259574574=""
                                    className="login-success"
                                  >
                                    <b
                                      _ngcontent-ng-c3259574574=""
                                      className="text-success"
                                    >
                                      Login Success
                                    </b>
                                  </span>
                                </td>
                                <td _ngcontent-ng-c3259574574="">
                                  {item?.ipAddress}
                                </td>
                                <td _ngcontent-ng-c3259574574="">
                                  {item?.userAgent}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-activity-log>
  );
}
